import React from "react";
import { color, radius, shadow } from "../../styles/theme";

/**
 * Standard content card — replaces the ad-hoc `{ background: "#fff",
 * borderRadius: 14, boxShadow: "..." }` object every page previously
 * redefined for itself. Kept as inline styles (matching this codebase's
 * convention) rather than a CSS class so per-usage padding/margin overrides
 * via `style` still compose cleanly.
 */
const Card = ({ children, padded = true, style, as: Tag = "div", ...rest }) => (
  <Tag
    style={{
      background: color.surface,
      border: `1px solid ${color.border}`,
      borderRadius: radius.lg,
      boxShadow: shadow.xs,
      padding: padded ? "18px 20px" : 0,
      ...style,
    }}
    {...rest}
  >
    {children}
  </Tag>
);

export default Card;
